import Button from 'components/_parts/atoms/button';
import CustomTable from 'components/_parts/atoms/table';
import LoadingCustom from 'components/layouts/loading/loading';
import { LevelDesc } from 'components/types/backOffice/company';
import dayjs from 'dayjs';
import { useOuterClick } from 'providers/OutsideClick';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import ModalLevelDesc from '../modal';

interface porpTypes {
  t : (key:string) => string
}

const customStyles = {
  headCells: {
    style: {
      fontSize: '12px',
      fontWeight: 'bold',
      textAlign: 'center',
      fontFamily: 'Quicksand',
      padding: '0px',
      justifyContent: 'start',
    },
  },
  cells: {
    style: {
      padding: '0px',
      justifyContent: 'start',
    },
  },
  rows: {
    style: {
      fontFamily: 'Quicksand',
      minHeight: '35px', // override the row height
      borderRadius: 0,
      filter: 'none',
      borderBottom: 'unset !important',
    },
  },
};

const ButtonEdit = styled(Button)`
  width: 100%;
  max-width: 70px;
  height: 24px;
  float: right;
`;

const CustomTableMod = styled.div`
  .rdt_TableBody {
    height: 500px;
    overflow: auto;
  }
`;
function Index(props: porpTypes) {
  const { t } = props;
  const [dataEdit, setDataEdit] = useState(null);
  const [id, setId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [typeForm, setTypeForm] = useState('');
  const { levelDescription = [], keyLevelDesc } = useSelector((state) => ({
    levelDescription: state?.company?.listLevelDesc?.data,
    keyLevelDesc: state?.loading?.listKey?.companyLevelDescription,
  }));
  const sortListLevelJobDesc = [...levelDescription].sort((a, b) => a.level - b.level);

  const innerRef = useOuterClick((e) => {
    if (
      e?.srcElement?.className && (e.srcElement?.className === 'modal fade show'
            || e.srcElement?.className?.includes('cs_modal-bg'))
    ) {
      setShowModal(false);
    }
  });

  const actionEdit = (data: LevelDesc, i:number) => (
    <ButtonEdit
      icon="edit"
      func={() => {
        setShowModal(true);
        setTypeForm('edit');
        setId(i);
        setDataEdit(data);
      }}
    >
      <span className="tw-ml-2">
        {t('org.structure_view.modal.edit')}
      </span>
    </ButtonEdit>
  );

  const columns = [
    {
      name: t('org.job_lvl.lvl'),
      sortField: true,
      selector: (row) => row.level,
      cellStyle: { verticalAlign: 'middle' },
    },
    {
      name: t('company.title_desc'),
      sortField: true,
      selector: (row) => row.title,
    },
    {
      name: t('org.employee.created_at'),
      sortField: true,
      selector: (row) => dayjs(row.created_at).format('D MMM YYYY') ?? '-',
      center: true,
      width: '20%',
    },
    {
      name: t('wla.status.table.created_by'),
      sortField: true,
      selector: (row) => row.created_by ?? '-',
      center: true,
      width: '20%',
    },
    {
      name: t('org.employee.action'),
      sortField: true,
      style: {
        justifyContent: 'center',
      },
      center: true,
      width: '15%',
      cell: (row, i) => actionEdit(row, i),
    },
  ];

  return (
    <>
      {showModal && (
      <ModalLevelDesc
        innerRef={innerRef}
        modal={showModal}
        funcModal={setShowModal}
        ids={id}
        data={dataEdit}
        funcId={() => setId}
        typeForm={typeForm}
        t={t}
      />
      )}
      <div
        className="tab-pane active position-relative"
        id="list_desc"
        role="tabpanel"
        style={{
          minHeight: '700px',
        }}
      >
        { keyLevelDesc ? <LoadingCustom /> : (
          <>
            <div className="row">
              <div className="col-8">
                <h4 className="title">{t('org.component.lvl_desc')}</h4>
              </div>
            </div>
            <CustomTableMod>
              <CustomTable
                columns={columns}
                data={sortListLevelJobDesc}
                customStyles={customStyles}
              />
            </CustomTableMod>
          </>
        ) }
      </div>
    </>
  );
}

export default Index;
